// WSContext.js
import { createContext } from "react";

const wsContext = createContext(null);

export default wsContext;
